import { NavLink } from "react-router-dom";

const NavProgramming = () => {
  return (
    <>
      <NavLink to="/programming">
        <p>Programming</p>
      </NavLink>
    </>
  );
};
export default NavProgramming;
